import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "~/components/ui/dialog"
import { Link } from "@remix-run/react"
import { Button } from "~/components/ui/button"
import { ReloadIcon } from "@radix-ui/react-icons"

export const SuccessDialog = ({ open, onOpenChange, title, content }: any) => {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="sm:max-w-[425px]">
        <DialogHeader>
          <DialogTitle className="text-success-foreground">{title}</DialogTitle>
          {typeof content === "string" ?
            <DialogDescription>{content}</DialogDescription>
          : <div>{content}</div>}
        </DialogHeader>
        <DialogFooter>
          <Button className="ml-2" size="sm" variant="outline" onClick={() => onOpenChange(false)}>
            Close
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  )
}

export const ConfirmDialog = ({ open, onOpenChange, submitting, title, content, onConfirm }: any) => {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="sm:max-w-[425px]">
        <DialogHeader>
          <DialogTitle dangerouslySetInnerHTML={{ __html: title }} />
          {typeof content === "string" ?
            <DialogDescription>{content}</DialogDescription>
          : <div>{content}</div>}
        </DialogHeader>
        <DialogFooter>
          <Button size="sm" onClick={onConfirm}>
            {submitting ?
              <span>
                <ReloadIcon className="inline mr-2 h-4 w-4 animate-spin" />
                Confirming...
              </span>
            : "Confirm"}
          </Button>
          <Button className="ml-2" size="sm" variant="outline" onClick={() => onOpenChange(false)}>
            Cancel
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  )
}

export const ActionPopup = ({ open, onOpenChange, title, content, buttonURL, buttonText }: any) => {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="sm:max-w-[425px]">
        <DialogHeader>
          <DialogTitle>{title}</DialogTitle>
          {typeof content === "string" ?
            <DialogDescription>{content}</DialogDescription>
          : <div>{content}</div>}
        </DialogHeader>
        <DialogFooter>
          <Link to={buttonURL}>
            <Button className="ml-2" size="lg" variant="default" onClick={() => onOpenChange(false)}>
              {buttonText}
            </Button>
          </Link>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  )
}
